import React from "react";

// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import TextInput from "../widgets/TextInput";
import FixButton from "../widgets/Button";
import TextNumberInput from "../widgets/TextNumberInput";
import addStipendio from "../services/addStipendio";
import moment from "moment";
import getImpostazioni from "../services/getImpostazioni";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });
export default class AddStipendio extends React.Component {

constructor(props){
    super (props)

    this.dataStipendio = '15';

    this.state = {
        dipendente: '',
        stipendio: '', 
        numeroMensilita: 12,
        error: false,
    };

}

async componentDidMount() {

    username = cookies.get('username', { path: '/' });
    token = cookies.get('token', { path: '/' });

    this.dataStipendio = await getImpostazioni(username, token);
    this.dataStipendio = this.dataStipendio.find(i => i.tipo === 'data_stipendi')
    if (!this.dataStipendio) {
        alert("É necessario definire la data di pagamento degli stipendi nelle impostazioni prima di proseguire.");
        window.location.href = '/#/app/stipendi';
        return;
    }
    this.dataStipendio = this.dataStipendio.payload;
    
    this.setState({});
}

render () {

    if (this.state.error) return <div/>;
    
    return (
    <>
        <PageTitle title={'Nuovo stipendio'} />  

        <TextInput name={'Nome e cognome dipendente'} value={this.state.dipendente} 
            onChange={(text) => { this.setState({dipendente: text})}
        } />

        <TextInput noState={true} name={'Stipendio base (mensile) del dipendente'} value={this.state.stipendio}
            onChange={(text) => {
                var t = text.replace(/\./g, '');
                if(/[^0-9,]+/.test(t)) {
                    t = t.replace(/[^0-9]+/g, '');
                }
                var chunks = t.split(',');
                chunks[0] = chunks[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                t = chunks.join(',');
                this.setState({stipendio: t.trim()});
            }}
        />

        <TextNumberInput name={'Mensilità'} value={this.state.numeroMensilita} 
            onChange={(text) => { this.setState({numeroMensilita: parseInt(text)})}
        } />

        <div style={{ height: 30 }}></div>
        <FixButton title={'Salva'} callback={() => this.save()} />
    </>
    );
}

    async save() {

        this.setState({ isLoading: true });

        if (!this.state.dipendente) {
            alert('Inserire un nome valido per il dipendente');
            return;
        }

        if (!this.state.stipendio) {
            alert('Inserire uno stipendio mensile base valido per proseguire.');
            return;
        }

        if (this.state.numeroMensilita > 15 || this.state.numeroMensilita < 12) {
            alert('Inserire un numero di mensilità compreso tra 12 e 15.');
            return;
        }

        var minimumDate = '01/01/' + moment().format('yyyy');
        var dataCheck = moment(this.dataStipendio + '/01/2022', 'DD/MM/yyyy')
        var custom = [
            ["2022"], 
            ["2023"], 
            ["2024"], 
            ["2025"]
        ];
        for (var i = 0; i < 4; i++) {
            for (var j = 0; j < 12; j++) {
                let stip = {
                    data: '15/' + dataCheck.format('MM/yyyy'), 
                    importo: dataCheck.isBefore(moment(minimumDate, 'DD/MM/yyyy')) ? "" : this.state.stipendio 
                }
                custom[i].push(stip);
                dataCheck = dataCheck.add(1, 'month');
            }
        }
                
        let stipendio = {
            dipendente: this.state.dipendente, 
            stipendio: this.state.stipendio, 
            mensilita: this.state.numeroMensilita, 
            custom: custom,
        };

        let res = await addStipendio(username, token, stipendio);
        if (res.result === 'ok') {
            window.location.href = '/#/app/stipendi';
            return;
        }

        this.setState({ isLoading: false });
        alert('Si è verificato un errore durante la creazione dello stipendio. Per favore, riprova.');
    }

}

